"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconAsterisk = function SvgIconAsterisk(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "asterisk icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Asterisk Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44 22.309l-15.036 4.079L38.8 39.223 32.463 44l-8.51-13.831L15.536 44 9.2 39.024l9.833-12.636L4 22.308l2.459-7.86 14.468 5.97L20.17 4h7.848l-.946 16.418 14.563-5.97z"
  }));
};

var _default = SvgIconAsterisk;
exports.default = _default;